import { Box } from '@mui/material';
import React from 'react';

interface Props {
  readonly actions: React.ReactNode | React.ReactNode[];
}

export const PageActions = ({ actions }: Props) => {
  if (!actions) {
    return null;
  }

  const actionsArray = Array.isArray(actions) ? actions : [actions];

  return (
    <Box display="flex" gap={1} ml="auto" alignItems="center">
      {actionsArray.map((action, index) => (
        <React.Fragment key={index}>{action}</React.Fragment>
      ))}
    </Box>
  );
};
